import axios from "axios";
import { profilerLanguageUrl, profilerUrl } from "../urls";
import { getTokenHeader, getToken } from "../../../../screen/auth/action";

export const getProfilerAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(profilerUrl(), getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to fetch account details' 
      });
    }
  });
};

export const getModulerProfilerAction = async (module) => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(`${profilerUrl()}?module=${module}`, getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to fetch account details' 
      });
    }
  });
};

export const UpdateProfilerAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .put(
        profilerUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const SendProfilerAction = (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        profilerUrl(),
        data,
        getTokenHeader(token)
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getLanguagesAction = async () => {
  return new Promise(async (next) => {
    try {
      let token = await getToken();
      const response = await axios.get(profilerLanguageUrl(), getTokenHeader(token));
      return next(response.data);
    } catch (err) {
      return next({ 
        error: true, 
        message: err.response?.data?.message || 'Failed to fetch languages' 
      });
    }
  });
};
